import { ReactNode, createContext, useState } from 'react'

interface InitContextProps {
  numberFrom: string
  updateNumberFrom: (value: string) => void
  numberTo: string
  updateNumberTo: (value: string) => void
  updateItemCollectionGuid: (value: string) => void
}

export const FilterItemNumberContext = createContext({} as InitContextProps)

interface FilterItemNumberProps {
  children: ReactNode
}

export const FilterItemNumberProvider = ({
  children,
}: FilterItemNumberProps) => {
  const [numberFrom, setNumberFrom] = useState('')
  const [numberTo, setNumberTo] = useState('')
  const [itemCollectionGuid, setItemCollectionGuid] = useState('')

  const updateItemCollectionGuid = (value: string) => {
    //If the itemCollectionGuid is not the same as in the state we clear the filters
    if (value !== itemCollectionGuid) {
      setItemCollectionGuid(value)
      clearNumberFilters()
    }
  }

  const updateNumberFrom = (value: string) => {
    setNumberFrom(value)
  }

  const updateNumberTo = (value: string) => {
    setNumberTo(value)
  }

  const clearNumberFilters = () => {
    setNumberFrom('')
    setNumberTo('')
  }

  const value = {
    numberFrom,
    updateNumberFrom,
    numberTo,
    updateNumberTo,
    updateItemCollectionGuid,
  }

  return (
    <FilterItemNumberContext.Provider value={value}>
      {children}
    </FilterItemNumberContext.Provider>
  )
}
